module.exports = __webpack_public_path__ + "img/beer_id-94.043068c5.png";